(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ViewTransactions",
                {
                    url: "/Transactions",
                    component: "viewTransactions",
                    requiredPermissions: [{ AccessObject: "Transaction", ActionType: "Create" }],
                    resolve: {
                        transactions: ["transactionApi", function (transactionApi) {
                            return transactionApi.getTransactionsForUser();
                        }],
                        transactionStatus: ["transactionStatus", function (transactionStatus) {
                            return transactionStatus;
                        }],
                        transactionStagesToUiRouter: ["transactionStagesToUiRouter", function (transactionStagesToUiRouter) {
                            return transactionStagesToUiRouter;
                        }]
                    }
                });
        }
    ]);

    app.component("viewTransactions",
        {
            templateUrl: "/App/ViewTransactions/template.html",
            controller: viewTransactionsController,
            bindings: {
                transactions: "<",
                transactionStatus: "<",
                transactionStagesToUiRouter: "<"
            }
        });

    viewTransactionsController.$inject = ["$state", "_", "$q", "transactionDocumentApi", "transactionApi", "$window", "$mdDialog", "firelightSsoApi", "$scope", "$timeout"];

    function viewTransactionsController($state, _, $q, transactionDocumentApi, transactionApi, $window, $mdDialog, firelightSsoApi, $scope, $timeout) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                currentStatus: currentStatus,
                goToLast: goToLast,
                loadFiles: loadFiles,              
                downloadAll: downloadAll,
                download: download,
                startFirelightSso: startFirelightSso             
            });

        function goToLast(transaction) {
            var uiRouterState = _($ctrl.transactionStagesToUiRouter)
                .filter(function (stage) { return stage.TransactionStage === transaction.LastTransactionStage }).map("UiRouterRoute")
                .value()[0];

            $state.go(uiRouterState, { transactionId: transaction.Id });
        }

        function currentStatus(status) {
            var isLocked = _.findIndex($ctrl.transactionStatus.locked, function (item) {
                return item.Value === status;
            });

            if (isLocked !== -1) {
                return true;
            } else {
                return false;
            }
        }

        function getStage() {
            ng.forEach($ctrl.transactions,
                function (t) {
                    if (t.TransactionStatus !== "PaperApplication") {
                        t.stageText = "Currently At:";
                    } else {
                        t.stageText = "Awaiting:";
                    }

                    if (t.TransactionStatus === "SubmittedToFirelight" && t.CurrentWorkflowQueue === null)
                        t.stageText = "";

                    if (t.CurrentWorkflowQueue) {
                        t.statusText = t.CurrentWorkflowQueue;
                    } else {
                        if (t.TransactionStatus === "PaperApplication") {
                            t.statusText = "Paper Application";
                        }
                    }

                    if (t.TransactionReviewStatus !== null) {
                        if (t.TransactionReviewStatus)
                            t.statusText = "Approved";
                        else
                            t.statusText = "Declined";
                        t.stageText = "Application was: ";
                    }
                });
        };

        getStage();

        function loadFiles(transaction) {
            if (!!transaction.showFiles) {
                transaction.loadingFiles = true;               
                             
                var promises = [];
                transaction.transactionDocuments = [];
                promises.push(transactionDocumentApi.getTransactionDocuments(transaction.Id).then(function (docs) {
                    if (docs.length > 0) {
                        transaction.transactionDocuments = docs;
                    }
                }));

                promises.push(transactionApi.getSummaryExists(transaction.Id).then(function (summary) {                          
                    if (summary !== null && summary === true) {
                        transaction.transactionDocuments.push({                             
                            RequiredFileName: "Summary",
                            Id: "summary"
                        });
                    }                                                                   
                }));

                promises.push(transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.Id).then(function (rightBridgeResponse) {
                    if (rightBridgeResponse !== null && rightBridgeResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RightBRIDGE",
                            Id: "rightbridge"
                        });   
                    }                      
                }));

                promises.push(transactionApi.getTransactionRetireUpResponse(transaction.Id).then(function (retireUpResponse) {
                    if (retireUpResponse !== null && retireUpResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RetireUp Pro",
                            Id: "retireup"
                        });
                    }                            
                }));

                $q.all(promises).then(function () {                     
                    return transaction.loadingFiles = false;
                }, function () {                      
                    return transaction.loadingFiles = false;
                });               
            }

            return transaction.loadingFiles = false;
        }

        function download(transaction, file) {      

            if (file.Id === "summary") {
                $window.open(transactionApi.getSummaryUrl(transaction.Id));
            }
            else if (file.Id === "rightbridge") {
                transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.Id).then(function (rightBridgeResponse) {
                    ng.forEach(rightBridgeResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRightBridgeTransactionDocumentUrl(transaction.Id, rightBridgeResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }

            else if (file.Id === "retireup") {
                transactionApi.getTransactionRetireUpResponse(transaction.Id).then(function (retireUpResponse) {
                    ng.forEach(retireUpResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRightBridgeTransactionDocumentUrl(transaction.Id, retireUpResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }

            else if (file.Id) {
                $window.open(transactionDocumentApi.getUrl(transaction.Id, file.Id));                
            }           
        }

        function downloadAll(transaction) {
                              
            ng.forEach(transaction.transactionDocuments, function (file) {
                download(transaction, file);
            });                               
        }        

        function startFirelightSso($event, transaction) {
            var w = window.open();
            w.document.write("Loading...");
            firelightSsoApi.InitiateFirelightSso(transaction.Id).then(function (data) {
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }        

        // TODO: dynamically fill this array (based on transaction status/stage)
        this.filterOptions = [];

        this.sortOptions = [
            { Label: "Oldest First", Value: "LastUpdatedOn" },
            { Label: "Newest First", Value: "-LastUpdatedOn" }
        ];
        $ctrl.ui.sortTransactions = $ctrl.sortOptions[0];
    }
})(window.app, window.angular); //jshint ignore:line
